import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaCogs } from 'react-icons/fa';
import './GuideModal.scss';

interface GuideModalProps {
  show: boolean;
  onClose: () => void;
}

const GuideModal: React.FC<GuideModalProps> = ({ show, onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="modifier-guide-modal" contentClassName="modifier-guide-content">
      <Modal.Header className="guide-header minimalist">
        <div className="guide-heading">
          <span className="guide-icon"><FaCogs /></span>
          <div className="guide-titles">
            <Modal.Title>Guía: Grupos Modificadores</Modal.Title>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="guide-body">
        <ol className="guide-steps">
          <li className="guide-step">
            <div className="step-badge">1</div>
            <div className="step-text">
              <h5>Crea un grupo modificador</h5>
              <p>Dale un nombre descriptivo. Ej: <strong>Tamaños Pizza</strong>, <strong>Temperatura Bebidas</strong>, <strong>Nivel de Cocción</strong>.</p>
            </div>
          </li>
          <li className="guide-step">
            <div className="step-badge">2</div>
            <div className="step-text">
              <h5>Agrega opciones intangibles</h5>
              <p>Incluye características que no requieren inventario: tamaños, temperaturas, estados, preferencias. <strong>No</strong> agregues productos físicos aquí.</p>
              <div className="mini-hint">Tip: Las opciones no consumen stock ni tienen costo de inventario.</div>
            </div>
          </li>
          <li className="guide-step">
            <div className="step-badge">3</div>
            <div className="step-text">
              <h5>Vincula a productos</h5>
              <p>Asocia el grupo a los productos donde los clientes pueden elegir estas características. Configura si es obligatorio u opcional.</p>
            </div>
          </li>
        </ol>

        <div className="examples-grid">
          <div className="example-card">
            <span className="example-label">Tamaños</span>
            <p>Chico, Mediano, Grande, Extra Grande.</p>
          </div>
          <div className="example-card">
            <span className="example-label">Temperatura</span>
            <p>Frío, Temperatura ambiente, Caliente.</p>
          </div>
          <div className="example-card">
            <span className="example-label">Cocción</span>
            <p>Término medio, Bien cocido, Poco cocido.</p>
          </div>
          <div className="example-card">
            <span className="example-label">Preparación</span>
            <p>Con hielo, Sin hielo, Extra hielo.</p>
          </div>
        </div>

        <div className="pro-tips">
          <h6>Importante</h6>
          <ul>
            <li><span><strong>Solo</strong> agrupa características intangibles (estados, tamaños, preferencias).</span></li>
            <li><span>Productos físicos con costo van en <strong>Grupos de Selección</strong> (que sí consumen stock). <a href="/App/SelectionGroups" className="inline-link">Ver Grupos de Selección</a></span></li>
            <li><span>Nombres claros ayudan al cliente a entender las opciones.</span></li>
            <li><span>Evita demasiadas opciones: simplicidad mejora la experiencia.</span></li>
            <li><span>Configura bien si es obligatorio u opcional para cada producto.</span></li>
          </ul>
        </div>

        <div className="scope-note" aria-label="Nota aclaratoria">
          <strong>¿Duda rápida?</strong> Si la opción tiene costo, requiere inventario, o es un producto que se vende por separado, <strong>no</strong> es un Modificador: es un <strong>Grupo de Selección</strong>. 
          <a href="/App/SelectionGroups" className="inline-link">Ir a Grupos de Selección</a>
        </div>
      </Modal.Body>
      <Modal.Footer className="guide-footer">
        <button className="close-btn" onClick={onClose}>Entendido</button>
      </Modal.Footer>
    </Modal>
  );
};

export default GuideModal;
